export const INITIAL_INCIDENTS_REQUEST = "INITIAL_INCIDENTS_REQUEST";
export const FETCH_INCIDENTS_SUCCESS = "FETCH_INCIDENTS_SUCCESS";
